import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import Achievements from '../../../components/Modal/Achievements';

// actions
import { requestFetchAchievements } from '../../../actions/achievements';

// selectors
import { getNotViewedAchievements, getAchievements } from '../../../reducers/achievements';

const mapStateToProps = (state, ownProps) => {
  return {
    notViewedAchievements: getNotViewedAchievements(state.achievements),
    allAchievements: getAchievements(state.achievements),
    modalData: ownProps.modalData,
  };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      requestFetchAchievements,
    },
    dispatch,
  );

export default connect(mapStateToProps, mapDispatchToProps)(Achievements);
